export default {
  businessThresholdConfig: '业务阈值配置',
  category: '分类',
  capacity: '板位容量',
  warehouse: '入仓差异',
  profit: '利润分析',
  alert: '临期提醒',
  security: '登录安全',
  hours: '小时',
  minutes: '分钟',
  times: '次',
  save: '保存',
  cancel: '取消',
  cancelOrder: '撤单',
  confirm: '确认',
  ok: '确定',
  delete: '删除',
  edit: '编辑',
  add: '新增',
  view: '查看',
  search: '查询',
  reset: '重置',
  submit: '提交',
  close: '关闭',
  back: '返回',
  export: '导出',
  exportOrders: '批量导出订单',
  import: '导入',
  download: '下载',
  upload: '上传',
  refresh: '刷新',
  operation: '操作',
  actions: '操作',
  status: '状态',
  remark: '备注',
  description: '描述',
  yes: '是',
  no: '否',
  all: '全部',
  none: '无',
  loading: '加载中...',
  noData: '暂无数据',
  success: '操作成功',
  failed: '操作失败',
  saveSuccess: '保存成功',
  deleteSuccess: '删除成功',
  updateSuccess: '更新成功',
  confirmDelete: '确认删除该记录？',
  confirmAction: '确认执行此操作？',
  required: '必填项',
  pleaseInput: '请输入',
  pleaseSelect: '请选择',
  language: '语言',
  switchLanguage: '切换语言',
  switchToChinese: '切换为中文',
  switchToEnglish: 'Switch to English',
  chinese: '中文',
  english: 'English',
  logout: '退出登录',
  changePassword: '修改密码',
  welcome: '欢迎',
  today: '今天',
  yesterday: '昨天',
  thisWeek: '本周',
  thisMonth: '本月',
  custom: '自定义',
  total: '合计',
  count: '数量',
  name: '名称',
  code: '代码',
  type: '类型',
  createTime: '创建时间',
  updateTime: '更新时间',
  createUser: '创建人',
  serialNo: '序号',
  unlinked: '未关联',
  currentStatus: '当前状态',
  complete: '完成',
  revokeComplete: '撤销完成',
  locked: '已锁定',
  unlocked: '未锁定',
  lock: '锁定',
  unlock: '解锁',
  fill: '填写',
  detail: '详情',
  to: '至',
  activate: '激活',
  deactivate: '失效',
  newCustomer: '新建客户',
  editCustomer: '编辑客户',
  enable: '启用',
  disable: '禁用',
  newUser: '新增用户',
  editUser: '编辑用户',
  resetPassword: '重置密码',
  forceChangePasswordOnReset: '重置密码后第一次登录必须修改密码',
  newDictionary: '新增字典',
  editDictionary: '编辑字典',
  newItem: '新增选项',
  editItem: '编辑选项',
  newAgreement: '新建协议',
  editAgreement: '编辑协议',
  newAgreementOrder: '新建协议委托号',
  editAgreementOrder: '编辑协议委托号',
  agreementDescription: '协议描述',
  addPalletType: '+ 添加板型',
  regenerateSubOrders: '重新均分',
  batchGenerateProductOrders: '批量生成产品委托号',
  everyMonth: '每月',
  confirmGenerate: '确认生成',
  keepCurrentAdjustment: '保留当前调整',
  // system 操作
  newRole: '新增角色',
  editRole: '编辑角色',
  assignPermission: '分配权限',
  newPermission: '新增权限',
  editPermission: '编辑权限',
  newChildPermission: '新增子权限',
  permissionTree: '权限树',
  permissionDetail: '权限详情',
  childPermissionList: '子权限列表',
  newOrganization: '新增组织',
  editOrganization: '编辑组织',
  orgStructure: '组织结构图',
  topLevel: '顶级',
  topOrg: '顶级组织',
  noOrgData: '暂无组织数据',
  queryAccountStatus: '查询账户状态',
  unlockAccount: '解锁该账户',
  serialNumberConfig: '编号关键词配置',
  bubbleConfig: '分泡配置',
  chargeWeightRuleConfig: '计费重计算规则',
  modify: '修改',
  pieceDetail: '单件信息',
  addRow: '新增行',
  recognizeAndFill: '识别填入',
  noReceivableDetail: '暂无应收明细',
  noPayableDetail: '暂无应付明细',
  actualWarehouse: '实际入仓',
  difference: '差异',
  additionalInfo: '附加信息',
  autoCalculated: '自动计算',
  newBizOrder: '新建业务委托号',
  viewOtherTabs: '查看其他Tab',
  loadingMore: '加载更多...',
  scrollToLoadMore: '滚动加载更多',
  receivable: '应收',
  pendingBackfill: '待补录',
  backfilled: '已回填',
  other: '其他',
  bubble: '分泡',
  bubbleRatioPrefix: '泡比1:',
  bubbleShareLabel: '{ratio}分泡',
  discountAmount: '让利金额',
  recalc: '重新试算',
  cancelBubble: '取消分泡',
  bubbleQuoteCalc: '分泡报价试算',
  localPayable: '本地应付',
  originalPrice: '原价',
  includesReceivableDetail: '含应收明细',
  copyNew: '复制新建',
  cargoChange: '货运货物变更',
  revertToDraft: '撤回至草稿',
  submitPendingBooking: '提交待订舱',
  confirmNew: '确认新建',
  create: '创建',
  applyToQuote: '应用到报价',
  applyToWeight: '应用到计费重量',
  // entry/dialogs
  iSee: '我知道了',
  confirmLock: '确认锁定',
  confirmDissolve: '确认撤舱',
  submitHandling: '提交处理',
  editMawb: '编辑主单号',
  newMawb: '新增主单号',
  newProductOrder: '新增产品委托号',
  editProductOrder: '编辑产品委托号',
  confirmCreate: '确认创建',
  reselect: '重新选择',
  dissolve: '撤舱',
  // entry/components/ChangeRequestDrawer
  approveChange: '同意变更',
  rejectChange: '驳回变更',
  confirmReject: '确认驳回',
  // entry/components/CargoModeView
  unknown: '未知',
  // entry/components/RightPanel
  advancedFilter: '高级筛选',
  filter: '筛选',
  batchMatch: '批量匹配',
  cancelSelection: '取消选择',
  // entry/components/WarehouseConfirmDrawer
  confirmAdd: '确认新增',
  // entry/components/PendingWarehouseZone
  cancelMatch: '取消匹配',
  gotIt: '知道了',
  confirmWarehouse: '确认建单',
  // entry/RouteEntryView deviation dialog
  accept: '接受',
  adjust: '调整',
  reject: '不接受',
  dialog: {
    bizOrderDetail: '业务委托详情',
    bizOrderCreateTitle: '新建业务委托号',
    bizOrderEditTitle: '编辑业务委托号',
    bizOrderCopyTitle: '复制新建业务委托号',
  },
  tab: {
    basicInfo: '基本信息',
    freightInfo: '货运信息',
    cargoInfo: '货物信息',
    warehouseData: '入仓数据',
    relationInfo: '关联信息',
    incomeInfo: '收入信息',
    costProfit: '成本与毛利',
    profitShare: '分润明细',
    receivableDetail: '应收明细',
    payableDetail: '应付明细',
    operationLog: '操作日志',
    salesCost: '销售成本',
    trunkCost: '干线成本',
    profitShareCombined: '毛利与分润',
    financeDetail: '财务汇总',
    cargoList: '货物清单',
    customerInfo: '客户信息',
  },
  login: {
    subtitle: import.meta.env.VITE_LOGIN_SUBTITLE || '空运航线运营系统（测试）',
    button: '登录',
    changePasswordTitle: '修改密码',
    mustChangeAlert: '您的密码为系统初始密码，请立即修改',
    confirmModify: '确认修改',
    clickToRefresh: '点击刷新',
  },
  // entry/components/CenterPanel/MasterOrderList
  addMawb: '领用主单号',
  switchToCompactMode: '切换为精简模式',
  switchToCardMode: '切换为卡片模式',
  // entry/components/CenterPanel/MasterOrderItem/HawbCard
  cancelWarehouse: '取消入仓',
  handleDiff: '处理差异',
  // cs-workbench/components/CenterPanel/BizOrderForm/WarehouseDataSection
  inputActualData: '录入实际数据',
}
